import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, Switch } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import AppContainer from "./AppContainer";
import Dashboard from "./Pages/Dashboard";
import Deposit from "./Pages/Deposit";
import DepositPayment from "./Pages/DepositPayment";
import ManagedAccount from "./Pages/ManagedAccount";
import Myplans from "./Pages/Myplans";
import Profile from "./Pages/Profile";
import ProfitsHistory from "./Pages/ProfitsHistory";
import Refferals from "./Pages/Refferals";
import TradingPlans from "./Pages/TradingPlans";
import Transactions from "./Pages/Transactions";
import TransferFunds from "./Pages/TransferFunds";
import Withdrawal from "./Pages/Withdrawal";
import WithdrawalComplete from "./Pages/WithdrawalComplete";
import "./App.css"


function App() {

  return (
    <GlobalState>
      {/* <ToastContainer className="foo" /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AppContainer />} />
          <Route path="/dashboards" element={<Dashboard />} />
          <Route path="/deposit" element={<Deposit />} />
          <Route path="/DepositPayment" element={<DepositPayment />} />
          <Route path="/ManagedAccount" element={<ManagedAccount/>} />
          <Route path="/Myplans" element={<Myplans/>} />
          <Route path="/Profile" element={<Profile/>} />
          <Route path="/ProfitsHistory" element={<ProfitsHistory />} />
          <Route path="/Refferals" element={<Refferals />} />
          <Route path="/TradingPlans" element={<TradingPlans/>} />
          <Route path="/Transactions" element={<Transactions/>} />
          <Route path="/TransferFunds" element={<TransferFunds/>} />
          <Route path="/Withdrawal" element={<Withdrawal/>} />
          <Route path="/WithdrawalComplet" element={<WithdrawalComplete/>} />
        </Routes>
      </BrowserRouter>
    </GlobalState>
  );
}

export default App;
